module.exports = __webpack_public_path__ + "static/img/bg-en.6cc4f14c.webp";